<template>
  <div class="p-3 flex flex-col bg-key rounded-4xl">
    <div class="flex items-center gap-1 h-9 text-l-medium text-black-white" @click="handleOpenLog">
      <Icon icon="Writing-Wireframe-List" class="size-6" />
      <span class="underline text-brand-blue1 cursor-pointer">
        {{ $t('setting.about.errorLog.title') }}
      </span>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { Icon } from '@rapoo/element'

  const handleOpenLog = () => {
    window.electronAPI?.openLogFolder()
  }
</script>
